import React, { useState, useEffect } from 'react';
import "./UsersTasksPage.css";
import { useAuth } from '../auth/Auth';
import GeneralPoolColumn from './Fixfile';

function UsersTasksPage() {
  const { user } = useAuth();
  const [webhooks, setWebhooks] = useState([]);
  const [archivedTasks, setArchivedTasks] = useState([]);
  const [kpiTasks, setKpiTasks] = useState([]);
  const [dutyData, setDutyData] = useState([]);
  const [dutyStatuses, setDutyStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [configLoading, setConfigLoading] = useState(false);
  const [error, setError] = useState('');
  const [collapsedStatuses, setCollapsedStatuses] = useState({});
  const [collapsedUsers, setCollapsedUsers] = useState({});
  const [showArchive, setShowArchive] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showDisplayMode, setShowDisplayMode] = useState(false);
  const [componentPosition, setComponentPosition] = useState('right');
  const [theme, setTheme] = useState('white');
  const [kpiLoading, setKpiLoading] = useState(false);
  
  // Нова змінна для режиму відображення
  const [displayMode, setDisplayMode] = useState(() => {
    const saved = localStorage.getItem('display-mode');
    return saved !== null ? saved : 'single-row';
  });

  const [showDutyTask, setShowDutyTask] = useState(() => {
    const saved = localStorage.getItem('filter-showDutyTask');
    return saved !== null ? JSON.parse(saved) : true;
  });
  
  const [showDutyChat, setShowDutyChat] = useState(() => {
    const saved = localStorage.getItem('filter-showDutyChat');
    return saved !== null ? JSON.parse(saved) : true;
  });
  
  const [showMentor, setShowMentor] = useState(() => {
    const saved = localStorage.getItem('filter-showMentor');
    return saved !== null ? JSON.parse(saved) : true;
  });
  
  const [showCoordinator, setShowCoordinator] = useState(() => {
    const saved = localStorage.getItem('filter-showCoordinator');
    return saved !== null ? JSON.parse(saved) : true;
  });
  
  // Додаємо стан для Тімлід
  const [showTeamlead, setShowTeamlead] = useState(() => {
    const saved = localStorage.getItem('filter-showTeamlead');
    return saved !== null ? JSON.parse(saved) : true;
  });
  
  const userId = user?.user_id || localStorage.getItem('userId') || '271';

  // Функція для завантаження конфігурації теми
  const fetchThemeConfig = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/user-theme-config/${userId}`);
      if (response.ok) {
        const config = await response.json();
        setTheme(config.theme || 'white');
        console.log('Theme loaded:', config.theme);
      } else {
        console.error('Failed to fetch theme config:', response.status);
        setTheme('white');
      }
    } catch (error) {
      console.error('Error fetching theme config:', error);
      setTheme('white');
    }
  };

  // Функція для завантаження KPI задач
  const fetchKpiTasks = async () => {
    try {
      console.log('Fetching KPI tasks...');
      const response = await fetch(`https://hub2.daolog.net/api/kpi-tasks`);
      if (response.ok) {
        const data = await response.json();
        console.log('KPI tasks received:', data);
        if (data.success) {
          setKpiTasks(data.kpiTasks || []);
        }
      } else {
        console.error('Failed to fetch KPI tasks:', response.status);
      }
    } catch (error) {
      console.error('Error fetching KPI tasks:', error);
    }
  };

  // Функція для додавання задачі в KPI
  const addKpiTask = async (taskData) => {
    setKpiLoading(true);
    try {
      const sessionId = `${taskData.TaskLink || taskData.taskLink}_${new Date(taskData.receivedAt).getTime()}`;
      console.log('Adding KPI task with sessionId:', sessionId);
      
      const response = await fetch(`https://hub2.daolog.net/api/kpi-task`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          taskData: {
            ...taskData,
            sessionId: sessionId,
            receivedAt: taskData.receivedAt
          },
          markedBy: userId,
          markedAt: new Date().toISOString()
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('Add KPI response:', data);
        if (data.success) {
          await fetchKpiTasks(); // Оновлюємо список
        }
      } else {
        console.error('Failed to add KPI task:', response.status);
      }
    } catch (error) {
      console.error('Error adding KPI task:', error);
    } finally {
      setKpiLoading(false);
    }
  };

  // Функція для видалення задачі з KPI
  const removeKpiTask = async (taskData) => {
    setKpiLoading(true);
    try {
      const sessionId = `${taskData.TaskLink || taskData.taskLink}_${new Date(taskData.receivedAt).getTime()}`;
      console.log('Removing KPI task with sessionId:', sessionId);
      
      const response = await fetch(`https://hub2.daolog.net/api/kpi-task/${encodeURIComponent(sessionId)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('Remove KPI response:', data);
        if (data.success) {
          await fetchKpiTasks(); // Оновлюємо список
        }
      } else {
        console.error('Failed to remove KPI task:', response.status);
      }
    } catch (error) {
      console.error('Error removing KPI task:', error);
    } finally {
      setKpiLoading(false);
    }
  };

  // Функція для перевірки, чи задача в списку KPI
  const isKpiTask = (taskLink, receivedAt) => {
    if (!taskLink || !receivedAt) return false;
    
    const sessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
    
    return kpiTasks.some(task => {
      // Спочатку перевіряємо за sessionId
      if (task.sessionId === sessionId) {
        return true;
      }
      
      // Якщо немає sessionId, перевіряємо за taskLink та часом
      const taskReceivedAt = new Date(task.receivedAt || task.originalReceivedAt).getTime();
      const currentReceivedAt = new Date(receivedAt).getTime();
      const taskLinkMatch = (task.TaskLink || task.taskLink) === taskLink;
      const timeMatch = Math.abs(taskReceivedAt - currentReceivedAt) < 60000;
      
      return taskLinkMatch && timeMatch;
    });
  };

  // Функція для перемикання KPI статусу
  const toggleKpiTask = async (task) => {
    if (kpiLoading) return; // Запобігаємо множинним клікам
    
    console.log('Toggling KPI task:', task);
    const taskLink = task.TaskLink || task.taskLink;
    const receivedAt = task.receivedAt;
    
    if (isKpiTask(taskLink, receivedAt)) {
      console.log('Removing from KPI...');
      await removeKpiTask(task);
    } else {
      console.log('Adding to KPI...');
      await addKpiTask(task);
    }
  };

  useEffect(() => {
    if (user?.user_id) {
      localStorage.setItem('userId', user.user_id);
    }
  }, [user?.user_id]);

  // Завантажуємо тему при завантаженні компонента
  useEffect(() => {
    fetchThemeConfig();
  }, [userId]);

  // Завантажуємо KPI задачі при завантаженні компонента
  useEffect(() => {
    fetchKpiTasks();
  }, []);

  useEffect(() => {
    localStorage.setItem('filter-showDutyTask', JSON.stringify(showDutyTask));
  }, [showDutyTask]);

  useEffect(() => {
    localStorage.setItem('filter-showDutyChat', JSON.stringify(showDutyChat));
  }, [showDutyChat]);

  useEffect(() => {
    localStorage.setItem('filter-showMentor', JSON.stringify(showMentor));
  }, [showMentor]);

  useEffect(() => {
    localStorage.setItem('filter-showCoordinator', JSON.stringify(showCoordinator));
  }, [showCoordinator]);

  useEffect(() => {
    localStorage.setItem('filter-showTeamlead', JSON.stringify(showTeamlead));
  }, [showTeamlead]);

  useEffect(() => {
    localStorage.setItem('display-mode', displayMode);
  }, [displayMode]);

  // Завантаження конфігурації компонента
  useEffect(() => {
    const loadComponentConfig = async () => {
      setConfigLoading(true);
      try {
        if (!userId) {
          setComponentPosition('right');
          return;
        }

        console.log('Loading component config for user:', userId);
        
        // Спробуємо отримати конфіг
        const response = await fetch(`https://hub2.daolog.net/user-component-config/${userId}`);
        
        if (response.ok) {
          const data = await response.json();
          console.log('Config loaded:', data);
          setComponentPosition(data.column || 'right');
        } else if (response.status === 404) {
          // Якщо конфіг не знайдено, створюємо дефолтний
          console.log('Config not found, creating default...');
          await fetch(`https://hub2.daolog.net/update-user-component-config/${userId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ column: 'right' })
          });
          setComponentPosition('right');
        } else {
          console.log('Unexpected response:', response.status);
          setComponentPosition('right');
        }
      } catch (error) {
        console.error('Error loading component config:', error);
        setComponentPosition('right');
      } finally {
        setConfigLoading(false);
      }
    };
    
    loadComponentConfig();
  }, [userId]);

  // Функція для оновлення конфігурації
  const updateComponentPosition = async (newPosition) => {
    try {
      console.log('Updating component position to:', newPosition);
      
      const response = await fetch(`https://hub2.daolog.net/update-user-component-config/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ column: newPosition })
      });
      
      if (response.ok) {
        const data = await response.json();
        setComponentPosition(data.column);
        setShowSettings(false);
        console.log(`Component position updated to: ${data.column}`);
      } else {
        console.error('Failed to update component position, status:', response.status);
      }
    } catch (error) {
      console.error('Error updating component position:', error);
    }
  };

  // Функція для зміни режиму відображення
  const updateDisplayMode = (mode) => {
    setDisplayMode(mode);
    setShowDisplayMode(false);
  };

  const resetAllFilters = () => {
    setShowDutyTask(true);
    setShowDutyChat(true);
    setShowMentor(true);
    setShowCoordinator(true);
    setShowTeamlead(true);
  };

  const selectFilter = (type) => {
    switch(type) {
      case 'duty_task':
        setShowDutyTask(true);
        setShowDutyChat(false);
        setShowMentor(false);
        setShowCoordinator(false);
        setShowTeamlead(false);
        break;
      case 'duty_chat':
        setShowDutyTask(false);
        setShowDutyChat(true);
        setShowMentor(false);
        setShowCoordinator(false);
        setShowTeamlead(false);
        break;
      case 'mentor':
        setShowDutyTask(false);
        setShowDutyChat(false);
        setShowMentor(true);
        setShowCoordinator(false);
        setShowTeamlead(false);
        break;
      case 'coordinator':
        setShowDutyTask(false);
        setShowDutyChat(false);
        setShowMentor(false);
        setShowCoordinator(true);
        setShowTeamlead(false);
        break;
      case 'teamlead':
        setShowDutyTask(false);
        setShowDutyChat(false);
        setShowMentor(false);
        setShowCoordinator(false);
        setShowTeamlead(true);
        break;
      default:
        resetAllFilters();
    }
  };

  const activeStatuses = [
    { key: 'Черговому', label: 'Черговому' },
    { key: 'Дежурному', label: 'Дежурному' },
    { key: 'В роботі', label: 'В роботі' },
    { key: 'В работе', label: 'В роботі' },
    { key: 'In progress', label: 'В роботі' },
    { key: 'В черзі', label: 'В черзі' },
    { key: 'В очереди', label: 'В черзі' },
    { key: 'В черзі (м\'яч не у нас)', label: 'В черзі (м\'яч не у нас)' },
    { key: 'В очереди (мяч не у нас)', label: 'В черзі (м\'яч не у нас)' }
  ];

  const excludedStatuses = [
    'Скасоване', 'Виконане', 'Відкладене', 'Отложенная',
    'Canceled', 'Completed', 'Postponed', 'Deleted', 
  ];

  const roleIcons = {
    'duty_task_yes': '📋',
    'duty_chat_yes': '💬',
    'mentor_yes': '🎓',
    'coordinator_yes': '⭐',
    'teamlead_yes': '👨‍💼'
  };

  const roleNames = {
    'duty_task_yes': 'Задачні',
    'duty_chat_yes': 'Чатні',
    'mentor_yes': 'Ментори',
    'coordinator_yes': 'Координатори',
    'teamlead_yes': 'Тімлід'
  };

  const rolePriority = {
    'duty_task_yes': 1,
    'duty_chat_yes': 2,
    'mentor_yes': 3,
    'coordinator_yes': 4,
    'teamlead_yes': 5
  };

  const getUsersOnDuty = (dutyData) => {
    if (!dutyData || !Array.isArray(dutyData)) {
      console.log('No duty data available');
      return [];
    }

    const latestActions = {};
    
    dutyData.forEach(entry => {
      const userId = entry.who;
      const action = entry.action;
      const receivedAt = new Date(entry.receivedAt);
      
      if (!latestActions[userId] || receivedAt > new Date(latestActions[userId].receivedAt)) {
        latestActions[userId] = {
          action: action,
          receivedAt: entry.receivedAt,
          startdate: entry.startdate
        };
      }
    });

    const usersOnDuty = Object.keys(latestActions).filter(userId => {
      const action = latestActions[userId].action;
      return action.includes('_yes');
    });

    console.log('Users on duty:', usersOnDuty);
    return usersOnDuty;
  };

  const getUserMainRole = (userId) => {
    if (!dutyData || !Array.isArray(dutyData)) return null;

    const userEntries = dutyData
      .filter(entry => entry.who === userId)
      .sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));

    if (userEntries.length > 0) {
      const latestEntry = userEntries[0];
      const action = latestEntry.action;
      
      if (action === 'duty_task_yes') return 'duty_task_yes';
      if (action === 'duty_chat_yes') return 'duty_chat_yes';
      if (action === 'mentor_yes') return 'mentor_yes';
      if (action === 'coordinator_yes') return 'coordinator_yes';
      if (action === 'teamlead_yes') return 'teamlead_yes';
    }

    return null;
  };

  const getUserAllRoles = (userId) => {
    if (!dutyData || !Array.isArray(dutyData)) return [];

    const userEntries = dutyData
      .filter(entry => entry.who === userId)
      .sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));

    const activeRoles = [];
    
    userEntries.forEach(entry => {
      const action = entry.action;
      if (action === 'duty_task_yes' && !activeRoles.includes('duty_task_yes')) {
        activeRoles.push('duty_task_yes');
      }
      if (action === 'duty_chat_yes' && !activeRoles.includes('duty_chat_yes')) {
        activeRoles.push('duty_chat_yes');
      }
      if (action === 'mentor_yes' && !activeRoles.includes('mentor_yes')) {
        activeRoles.push('mentor_yes');
      }
      if (action === 'coordinator_yes' && !activeRoles.includes('coordinator_yes')) {
        activeRoles.push('coordinator_yes');
      }
      if (action === 'teamlead_yes' && !activeRoles.includes('teamlead_yes')) {
        activeRoles.push('teamlead_yes');
      }
    });

    return activeRoles;
  };

  const toggleStatusCollapse = (statusKey) => {
    setCollapsedStatuses(prev => ({
      ...prev,
      [statusKey]: !prev[statusKey]
    }));
  };

  const toggleUserCollapse = (userName) => {
    setCollapsedUsers(prev => ({
      ...prev,
      [userName]: !prev[userName]
    }));
  };

  const calculateTimeInStatus = (receivedAt) => {
    if (!receivedAt) return '0хв';
    
    const receivedTime = new Date(receivedAt);
    const now = new Date();
    const diffMs = now - receivedTime;
    
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hours > 0) {
      return `${hours}год ${minutes}хв`;
    }
    return `${minutes}хв`;
  };

  const archiveTask = async (task) => {
    try {
      const response = await fetch('https://hub2.daolog.net/api/archive-task', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          taskData: task,
          archivedBy: userId,
          archivedAt: new Date().toISOString()
        })
      });

      if (response.ok) {
        setArchivedTasks(prev => [...prev, {
          ...task,
          archivedBy: userId,
          archivedAt: new Date().toISOString()
        }]);
        
        setWebhooks(prev => prev.filter(w => 
          (w.TaskLink || w.taskLink) !== (task.TaskLink || task.taskLink)
        ));
        
        console.log('Задачу успішно архівовано');
      } else {
        console.error('Помилка архівування задачі');
      }
    } catch (error) {
      console.error('Помилка архівування:', error);
    }
  };

  const restoreTask = async (archivedTask) => {
    try {
      const response = await fetch('https://hub2.daolog.net/api/restore-task', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          taskLink: archivedTask.TaskLink || archivedTask.taskLink
        })
      });

      if (response.ok) {
        setArchivedTasks(prev => prev.filter(task => 
          (task.TaskLink || task.taskLink) !== (archivedTask.TaskLink || archivedTask.taskLink)
        ));
        
        console.log('Задачу успішно відновлено');
      } else {
        console.error('Помилка відновлення задачі');
      }
    } catch (error) {
      console.error('Помилка відновлення:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        setError('');
        
        console.log('Starting data fetch...');
        
        const [webhooksResponse, archiveResponse, dutyResponse, dutyStatusesResponse, kpiResponse] = await Promise.all([
          fetch(`https://hub2.daolog.net/api/all-webhooks`),
          fetch(`https://hub2.daolog.net/api/archived-tasks`),
          fetch(`https://hub2.daolog.net/api/duty-data`),
          fetch(`https://hub2.daolog.net/api/duty-statuses`),
          fetch(`https://hub2.daolog.net/api/kpi-tasks`)
        ]);
        
        if (!webhooksResponse.ok) {
          throw new Error(`Помилка отримання вебхуків: ${webhooksResponse.status}`);
        }
        
        const webhooksData = await webhooksResponse.json();
        const archiveData = await archiveResponse.json();
        const dutyDataResponse = await dutyResponse.json();
        const dutyStatusesData = await dutyStatusesResponse.json();
        
        if (kpiResponse.ok) {
          const kpiData = await kpiResponse.json();
          console.log('KPI data received in fetchData:', kpiData);
          if (kpiData.success) {
            setKpiTasks(kpiData.kpiTasks || []);
          }
        }
        
        if (webhooksData.success) {
          setWebhooks(webhooksData.webhooks || []);
        } else {
          setError('Невірний формат даних від сервера');
        }

        if (archiveData.success) {
          setArchivedTasks(archiveData.archivedTasks || []);
        }

        if (dutyDataResponse.success) {
          setDutyData(dutyDataResponse.dutyData || []);
        } else {
          setDutyData([]);
        }

        if (dutyStatusesData.success) {
          setDutyStatuses(dutyStatusesData.dutyStatuses || {});
        } else {
          setDutyStatuses({});
        }
        
      } catch (error) {
        console.error('Помилка завантаження даних:', error);
        setError(`Помилка завантаження даних: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [userId]);

  const getArchivedTaskLinks = () => {
    return archivedTasks.map(task => task.TaskLink || task.taskLink);
  };

  const groupedByTask = webhooks.reduce((acc, webhook) => {
    const taskLink = webhook.TaskLink || webhook.taskLink || 'unknown';
    
    const archivedLinks = getArchivedTaskLinks();
    if (archivedLinks.includes(taskLink)) {
      return acc;
    }
    
    if (!acc[taskLink]) {
      acc[taskLink] = [];
    }
    acc[taskLink].push(webhook);
    return acc;
  }, {});

  const latestWebhooks = Object.entries(groupedByTask).map(([taskLink, taskWebhooks]) => {
    taskWebhooks.sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));
    return taskWebhooks[0];
  });

  const activeWebhooks = latestWebhooks.filter(webhook => {
    const taskStatus = webhook.TaskStatus || webhook.taskStatus || '';
    
    const isExcluded = excludedStatuses.some(excludedStatus => 
      taskStatus === excludedStatus
    );
    
    return !isExcluded;
  });

  const userNamesMap = {
    '08a376410d57a49080f6437a6769e765': 'Пастушенко Карина',
    '6186dc0de930c4489f1cb0263fee3cb9': "Левицький Мар'ян",
    '96936d574385ce2328b697d75cc9ed25': 'Стецько Андрій',
    '7ae8cd52c6b536e7948e163d7eb79be1': 'Сенишин Максим.',
    '1c6c7ce92c2e99adb56f8a8743ef2c42': 'Грет Орест',
    '181919b1f3bb927d217d617c4938a885': 'Козак Дмитро',
    'e33d394cde1c7788e4371a5df8c91e7f': 'Герій Олег',
    '888c3b61bb6fc84e462cace3802f5a80': 'Островська Катерина',
    '68cbc91a9357786b674d12f48dbeec5e': 'Павлюк Микола',
    '32478442b5013f8cef0c0a8b07f72dce': 'Коневич Роман',
    'ed863fbec1ec7d6360f62d54942f0655': 'Здеорук Вікторія',
    '8c0d7c9a8853178be96fa60ed8b0298b': 'Чічкін Ігор',
    '7115979f5af389e660bf57e21e10e73a': 'Рихлінський Руслан',
    '9e91681968c552d39c3943cd489de8dd': 'Віролюбова Анастасія',
    '1e9b56558fc6ef081b646ebce9c6d2b7': 'Николайчук Дарья',
    'e90cbdecf165c5b7501e6b52315e0481': 'Єсипович Євген',
    'ecb7033508c49fefc6f146fed1cdbde6': 'Левицький Микита',
    '70d9217877877f35c58a57729a36455e': 'Здеорук Олександра',
    '6b00290e92ccab45f933e1118fbc36f8': 'Петрів Юрій',
    '253db11e2987d6eebe524da08ca3c33a': 'Петрів Степан',
    '19149f434b36af055a1a14ee7dea719d': 'Рось Іван',
    '84053c23a95a2f20256e351a6464f38e': 'Бишко Данило',
    '70bab5c0b422829d5f51dd0c1a6a925e': 'Сальников Валентин',
    'ed2024a4e80d57e488ae8c16d6bc52eb': 'Зеленіков Дмитро',
    '76': 'Сачовська Діана',
    '045205e9750e89e7aa8a88eea1e90ba1': 'Сачовська Діана',
    '77': 'Дудар Максим',
    '528295c587f8204164b129b01c68f1f9': 'Дудар Максим',
    '4514b8da7b9d9ae0f612eb3a9316c2ee': 'Мелих Владислав',
    '78': 'Мелих Владислав',
    '5a2471cc0559c9bed479ebeaa2810456': 'Ванденко Максим',
    'Chat Manager Syrve POS Support': 'Chat Manager Syrve POS Support',
    '43481fb68ba4c410a7413a331ae63e2d': 'Шершньов Микита',
       'bfd39278cf8337ccbf4eb10878d229da': 'Даниленко Денис',
       '74fa21afdcce740f82d72c5f3b6b5d55': 'Шульська Аліна',
        'dc58ddc1c7a369bcf15936d93ed911d3': 'Роман Ірина',
       'b843e12a0cb74f150b46ce4869da2ba4': 'Клепацький Дмитро',
      '21a3c2811d3a9d5e80ae58ed2dee08af': 'Когут Марія',
       'a4512bf2acb5c96a3254c819f0a358d4': 'Морозюк Роман',
        '3b17ccb07571b6c02427fa6ebe584dc7': 'Мазурян Евеліна',
       'a707c5bab2d536a1df71095e588534b7': 'Нестерович Євгеній',
       '25009328c12e7616e397462b3ac403a7': 'Колбінов Валентин',
        '7ba3395596ec209f829d5f4b846d6cd7': 'Керніцька Христина',
     '725301d7478b0bf2e0db9c1c8c2c1234': 'Запольська Єлизавета',
       '2fc4fe00de48cd6b723a21cd17e562fc': 'Смирнова Кристина',
   
    'd9bc61c8d39e7373c61e61a04073b9a8': 'Гіщинський Любомир',
   
    'XCr0s5X': '4fee0b2cd341f9ca21a174006703164d',
    'Nikita': '43481fb68ba4c410a7413a331ae63e2d',
    '4fee0b2cd341f9ca21a174006703164d': 'Лебідь Роман',
    '84': 'Лебідь Роман',
  };

  const usersWithTasks = activeWebhooks.reduce((acc, webhook) => {
    const users = webhook.User || [];
    
    if (Array.isArray(users) && users.length > 0) {
      users.forEach(userId => {
        const usersOnDuty = getUsersOnDuty(dutyData);
        
        if (!usersOnDuty.includes(userId)) {
          return;
        }
        
        const userName = userNamesMap[userId] || ` ${userId}`;
        
        if (!acc[userId]) {
          const mainRole = getUserMainRole(userId);
          acc[userId] = {
            id: userId,
            name: userName,
            mainRole: mainRole,
            rolePriority: mainRole ? rolePriority[mainRole] : 6,
            tasks: []
          };
        }
        acc[userId].tasks.push(webhook);
      });
    }
    
    return acc;
  }, {});

  const getUsersWithoutTasks = () => {
    const usersOnDuty = getUsersOnDuty(dutyData);
    
    const usersWithoutTasks = [];
    
    usersOnDuty.forEach(userId => {
      if (!usersWithTasks[userId]) {
        const userName = userNamesMap[userId] || `${userId}`;
        const excludedUserNames = ['Користувач 1', 'Користувач 2', 'Користувач 7', 'Користувач 14', 'Користувач 32', 'Користувач 68', 'Користувач 688', 'Користувач 12'];
        
        if (!excludedUserNames.includes(userName)) {
          const mainRole = getUserMainRole(userId);
          usersWithoutTasks.push({
            id: userId,
            name: userName,
            mainRole: mainRole,
            rolePriority: mainRole ? rolePriority[mainRole] : 6,
            tasks: []
          });
        }
      }
    });
    
    return usersWithoutTasks;
  };

  const allAcceptedUsers = [
    ...Object.values(usersWithTasks),
    ...getUsersWithoutTasks()
  ];

  const sortedUsers = [...allAcceptedUsers].sort((a, b) => {
    return a.rolePriority - b.rolePriority;
  });

  const filteredUsers = sortedUsers.filter(user => {
    const excludedUserNames = ['Користувач 1', 'Користувач 2', 'Користувач 7', 'Користувач 14', 'Користувач 32', 'Користувач 68', 'Користувач 688', 'Користувач 12' , 'Ванденко Максим'];
    if (excludedUserNames.includes(user.name)) return false;
    
    if (user.mainRole === 'duty_task_yes' && !showDutyTask) return false;
    if (user.mainRole === 'duty_chat_yes' && !showDutyChat) return false;
    if (user.mainRole === 'mentor_yes' && !showMentor) return false;
    if (user.mainRole === 'coordinator_yes' && !showCoordinator) return false;
    if (user.mainRole === 'teamlead_yes' && !showTeamlead) return false;
    
    return true;
  });

  const isApplicationTask = (taskName) => {
    if (!taskName || typeof taskName !== 'string') return false;
    const excludedKeywords = ['заявка №', 'чергування', 'дежурство'];
    const lowerTaskName = taskName.toLowerCase();
    return excludedKeywords.some(keyword => lowerTaskName.includes(keyword));
  };
  
  const getTasksByStatus = (tasks, statusKey) => {
    return tasks.filter(task => {
      const taskStatus = task.TaskStatus || task.taskStatus;
      const implementerTask = task.implementer_task || task.ImplementerTask;
      const isNotImplementerTask = implementerTask !== 'Yes' && implementerTask !== 'Так';
      const taskName = task.TaskName || task.taskName || '';
      
      const isAppTask = typeof taskName === 'string' && isApplicationTask(taskName);
      
      return taskStatus === statusKey && isNotImplementerTask && !isAppTask;
    });
  };

  const TaskItem = ({ task, showArchiveButton = true }) => {
    const isBlocker = task.isBlocker === 'Термінове' || task.IsBlocker === 'Термінове';
    const taskLink = task.TaskLink || task.taskLink;
    const taskName = task.TaskName || task.taskName || 'Без назви';
    const projectName = task.ProjectName || task.projectName || '';
    const taskStatus = task.TaskStatus || task.taskStatus || '';
    const receivedAt = task.receivedAt;
    
    // Перевіряємо, чи задача в KPI
    const isKpi = isKpiTask(taskLink, receivedAt);
    
    const [currentTime, setCurrentTime] = useState(new Date());
    const [blinking, setBlinking] = useState(false);
    const [timeStatus, setTimeStatus] = useState(null);
    const [totalTimeInStatus, setTotalTimeInStatus] = useState('0:00');
    
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentTime(new Date());
      }, 1000);
      
      return () => clearInterval(interval);
    }, []);
    
    useEffect(() => {
      if (!receivedAt) {
        setTimeStatus(null);
        return;
      }
      
      const receivedTime = new Date(receivedAt);
      const now = currentTime;
      const taskTimer = task.TaskTimer || task.taskTimer || '';
      
      const standardCRI = {
        'В черзі': 15 * 60 * 1000,
        'В очереди': 15 * 60 * 1000,
        'В роботі': 30 * 60 * 1000,
        'В работе': 30 * 60 * 1000,
        'In progress': 30 * 60 * 1000,
      };
      
      let endTime = null;
      let timeLeft = 0;
      let totalTime = 0;
      let isExpired = false;
      let isWarning = false;
      
      if (taskTimer) {
        const timerMatch = taskTimer.match(/(\d+)\s*(хв|год|мин|ч)/);
        if (timerMatch) {
          const value = parseInt(timerMatch[1]);
          const unit = timerMatch[2];
          
          totalTime = unit.includes('год') || unit.includes('ч') 
            ? value * 60 * 60 * 1000 
            : value * 60 * 1000;
          
          endTime = new Date(receivedTime.getTime() + totalTime);
          timeLeft = endTime - now;
        }
      } else if (standardCRI[taskStatus]) {
        totalTime = standardCRI[taskStatus];
        endTime = new Date(receivedTime.getTime() + totalTime);
        timeLeft = endTime - now;
      } else {
        setTimeStatus(null);
        return;
      }
      
      if (endTime) {
        isExpired = timeLeft <= 0;
        const warningThreshold = 5 * 60 * 1000;
        isWarning = !isExpired && timeLeft <= warningThreshold;
        
        const formatTime = (ms) => {
          if (ms <= 0) {
            const overdueMs = -ms;
            const overdueHours = Math.floor(overdueMs / (1000 * 60 * 60));
            const overdueMinutes = Math.floor((overdueMs % (1000 * 60 * 60)) / (1000 * 60));
            const overdueSeconds = Math.floor((overdueMs % (1000 * 60)) / 1000);
            
            if (overdueHours > 0) {
              return `+${overdueHours}:${overdueMinutes.toString().padStart(2, '0')}:${overdueSeconds.toString().padStart(2, '0')}`;
            }
            return `+${overdueMinutes}:${overdueSeconds.toString().padStart(2, '0')}`;
          } else {
            const hours = Math.floor(ms / (1000 * 60 * 60));
            const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((ms % (1000 * 60)) / 1000);
            
            if (hours > 0) {
              return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            }
            return `${minutes}:${seconds.toString().padStart(2, '0')}`;
          }
        };
        
        const percentage = totalTime > 0 
          ? Math.max(0, Math.min(100, 100 - (timeLeft / totalTime * 100)))
          : 100;
        
        setTimeStatus({
          endTime,
          timeLeft,
          totalTime,
          isExpired,
          isWarning,
          timeText: formatTime(timeLeft),
          percentage,
          hasTimer: true,
          isQueueStatus: taskStatus === 'В черзі' || taskStatus === 'В очереди',
          isWorkStatus: taskStatus === 'В роботі' || taskStatus === 'В работе' || taskStatus === 'In progress'
        });
      } else {
        setTimeStatus(null);
      }
    }, [task, taskStatus, receivedAt, currentTime]);
    
    useEffect(() => {
      if (!receivedAt) {
        setTotalTimeInStatus('0:00');
        return;
      }
      
      const receivedTime = new Date(receivedAt);
      const now = currentTime;
      const diffMs = now - receivedTime;
      
      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
      
      if (hours > 0) {
        setTotalTimeInStatus(`${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
      } else {
        setTotalTimeInStatus(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      }
    }, [receivedAt, currentTime]);
    
    useEffect(() => {
      if (!timeStatus) return;
      
      let interval;
      
      if (timeStatus.isWarning) {
        interval = setInterval(() => {
          setBlinking(prev => !prev);
        }, 1000);
      } else if (timeStatus.isExpired) {
        interval = setInterval(() => {
          setBlinking(prev => !prev);
        }, 500);
      }
      
      return () => {
        if (interval) clearInterval(interval);
      };
    }, [timeStatus]);
    
    const getBlinkingStyle = () => {
      if (!blinking || !timeStatus) return {};
      
      let blinkColor = 'rgba(255, 0, 0, 0.2)';
      
      if (timeStatus.isWarning) {
        if (timeStatus.isQueueStatus) {
          blinkColor = 'rgba(255, 165, 0, 0.2)';
        } else if (timeStatus.isWorkStatus) {
          blinkColor = 'rgba(0, 123, 255, 0.2)';
        }
      } else if (timeStatus.isExpired) {
        if (timeStatus.isQueueStatus) {
          blinkColor = 'rgba(255, 165, 0, 0.4)';
        } else if (timeStatus.isWorkStatus) {
          blinkColor = 'rgba(0, 123, 255, 0.4)';
        }
      }
      
      return {
        backgroundColor: blinkColor,
        boxShadow: `0 0 10px ${blinkColor.replace('0.2', '0.4').replace('0.4', '0.6')}`
      };
    };

    const handleTaskClick = () => {
      window.open(taskLink, '_blank');
    };

    const handleArchiveClick = (e) => {
      e.stopPropagation();
      if (window.confirm('Ви дійсно хочете архівувати цю задачу?')) {
        archiveTask(task);
      }
    };

    const handleKpiClick = async (e) => {
      e.stopPropagation();
      e.preventDefault();
      await toggleKpiTask(task);
    };

    const isQueueOrWorkTask = taskStatus === 'В черзі' || taskStatus === 'В очереди' || 
                              taskStatus === 'В роботі' || taskStatus === 'В работе' || taskStatus === 'In progress';

    return (
      <div 
        className={`task-item ${isBlocker ? 'blocker' : ''} ${timeStatus?.isExpired ? 'expired' : ''}`}
        onClick={handleTaskClick}
        title={`${taskName}${projectName ? ` (${projectName})` : ''}`}
        style={{ 
          cursor: 'pointer', 
          position: 'relative',
          ...getBlinkingStyle(),
          transition: 'background-color 0.5s, box-shadow 0.5s'
        }}
      >
        {timeStatus && isQueueOrWorkTask && (
          <div 
            className="task-progress" 
            style={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: `${timeStatus.percentage}%`,
              backgroundColor: timeStatus.isExpired 
                ? (timeStatus.isQueueStatus ? 'rgba(255, 165, 0, 0.3)' : 'rgba(0, 123, 255, 0.3)')
                : (timeStatus.isWarning 
                    ? (timeStatus.isQueueStatus ? 'rgba(255, 165, 0, 0.2)' : 'rgba(0, 123, 255, 0.2)')
                    : (timeStatus.isQueueStatus ? 'rgba(255, 165, 0, 0.1)' : 'rgba(0, 123, 255, 0.1)')),
              transition: 'width 1s linear',
              zIndex: 0,
              borderRadius: '6px'
            }}
          />
        )}
        
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div className="task-header">
            <div className="task-name" title={taskName}>
              {taskName}
            </div>
            <div className="task-buttons">
              {/* Кнопка KPI (хрестик/галочка) */}
              <button 
                className={`kpi-btn ${isKpi ? 'active' : ''}`}
                onClick={handleKpiClick}
                title={isKpi ? 'Прибрати з KPI' : 'Додати в KPI'}
                disabled={kpiLoading}
              >
                {isKpi ? '✓' : '✗'}
              </button>
              
              {/* Кнопка архіву */}
              {showArchiveButton && (
                <button 
                  className="archive-btn"
                  onClick={handleArchiveClick}
                  title="Архівувати задачу"
                >
                  📁
                </button>
              )}
            </div>
          </div>
          
          <div className="task-times-container">
            <div className="total-time-in-status">
              <span className="time-value" style={{ 
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                {totalTimeInStatus}
              </span>
            </div>
            
            {timeStatus && isQueueOrWorkTask && (
              <div className="planned-time-remaining">
                <div className="time-row">
                  <span 
                    className="time-value" 
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: timeStatus.isExpired ? '#ff4444' : 
                            timeStatus.isWarning ? '#ff8800' : 
                            (timeStatus.isQueueStatus ? '#ff9800' : '#2196f3')
                    }}
                  >
                    {timeStatus.timeText}
                  </span>
                </div>
              </div>
            )}
          </div>
          
          {projectName && (
            <div className="task-project" title={projectName}>
              {projectName}
            </div>
          )}
        </div>
      </div>
    );
  };

  const ArchivedTaskItem = ({ task }) => {
    const taskLink = task.TaskLink || task.taskLink;
    const taskName = task.TaskName || task.taskName || 'Без назви';
    const projectName = task.ProjectName || task.projectName || '';
    const archivedBy = task.archivedBy || 'Невідомо';
    const archivedAt = task.archivedAt ? new Date(task.archivedAt).toLocaleString() : 'Невідомо';

    const handleTaskClick = () => {
      window.open(taskLink, '_blank');
    };

    const handleRestoreClick = (e) => {
      e.stopPropagation();
      if (window.confirm('Ви дійсно хочете відновити цю задачу?')) {
        restoreTask(task);
      }
    };

    return (
      <div 
        className="task-item archived"
        onClick={handleTaskClick}
        title={`${taskName}${projectName ? ` (${projectName})` : ''}`}
        style={{ cursor: 'pointer' }}
      >
        <div className="task-header">
          <div className="task-name" title={taskName}>
            {taskName}
          </div>
          <button 
            className="restore-btn"
            onClick={handleRestoreClick}
            title="Відновити задачу"
          >
            ↩️
          </button>
        </div>
        <div className="task-meta">
          <div>Архівовано: {archivedBy}</div>
          <div>Час: {archivedAt}</div>
        </div>
        {projectName && (
          <div className="task-project" title={projectName}>
            {projectName}
          </div>
        )}
      </div>
    );
  };

  // Отримуємо стилі розміщення в залежності від позиції
  const getLayoutContainerStyle = () => {
    switch (componentPosition) {
      case 'left':
        return { 
          className: 'layout-container side-layout left-layout',
          style: { display: 'grid', gridTemplateColumns: '300px 1fr', gap: '20px' }
        };
      case 'bottom':
        return { 
          className: 'layout-container bottom-layout',
          style: { display: 'flex', flexDirection: 'column', gap: '20px' }
        };
      case 'right':
      default:
        return { 
          className: 'layout-container side-layout right-layout',
          style: { display: 'grid', gridTemplateColumns: '1fr 300px', gap: '20px' }
        };
    }
  };

  const getGeneralPoolStyle = () => {
    switch (componentPosition) {
      case 'left':
        return { order: -1 };
      case 'bottom':
        return { order: 1, marginTop: '20px' };
      case 'right':
      default:
        return { order: 1 };
    }
  };

  // Функція для розбиття користувачів на ряди по 5 (тільки для режиму multiple-rows)
  const getRowsFromUsers = (users) => {
    if (displayMode === 'single-row') {
      return [users];
    }
    
    const rows = [];
    for (let i = 0; i < users.length; i += 5) {
      rows.push(users.slice(i, i + 5));
    }
    return rows;
  };

  // Рендер користувача
  const renderUserColumn = (user) => {
    const isUserCollapsed = collapsedUsers[user.name];
    
    return (
      <div key={user.id} className={`user-column ${isUserCollapsed ? 'collapsed' : ''}`}>
        <div 
          className="user-header"
          onClick={() => toggleUserCollapse(user.name)}
        >
          <div className="user-name">
            <span 
              className="role-icon" 
              title={user.mainRole ? roleNames[user.mainRole] : 'Немає ролі'}
            >
              {user.mainRole ? roleIcons[user.mainRole] : ''}
            </span>
            {user.name}
          </div>
          <button 
            className="collapse-btn"
            onClick={(e) => {
              e.stopPropagation();
              toggleUserCollapse(user.name);
            }}
            aria-label={isUserCollapsed ? "Розгорнути" : "Згорнути"}
          >
            {isUserCollapsed ? '▶' : '▼'}
          </button>
        </div>
        
        {!isUserCollapsed && (
          <div className="user-statuses">
            {user.tasks.length > 0 ? (
              activeStatuses.map(status => {
                const statusTasks = getTasksByStatus(user.tasks, status.key);
                if (statusTasks.length === 0) return null;
                
                const statusKey = `${user.id}-${status.key}`;
                const isStatusCollapsed = collapsedStatuses[statusKey];
                
                return (
                  <div key={status.key} className="status-section">
                    <div 
                      className="status-header"
                      onClick={() => toggleStatusCollapse(statusKey)}
                    >
                      <span 
                        className="status-name"
                        data-status={status.key}
                      >
                        {status.label}
                      </span>
                      <span className="task-count">({statusTasks.length})</span>
                      <span className="collapse-icon">
                        {isStatusCollapsed ? '▶' : '▼'}
                      </span>
                    </div>
                    
                    {!isStatusCollapsed && (
                      <div className="tasks-list">
                        {statusTasks.map(task => (
                          <TaskItem 
                            key={task.TaskLink || task.taskLink} 
                            task={task}
                            showArchiveButton={true}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="no-tasks-user">Немає активних задач</div>
            )}
          </div>
        )}
      </div>
    );
  };

  if (loading || configLoading) {
    return <div className={`users-tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}><div className="loading">Завантаження...</div></div>;
  }

  if (error) {
    return <div className={`users-tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}><div className="error">{error}</div></div>;
  }

  const layoutConfig = getLayoutContainerStyle();
  const userRows = getRowsFromUsers(filteredUsers);

  return (
    <div className={`users-tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}>
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Задачі користувачів</h1>
          <div className="header-controls">
            <button 
              className="display-mode-btn"
              onClick={() => setShowDisplayMode(!showDisplayMode)}
              title="Режим відображення"
            >
              ☷
            </button>
            
            {showDisplayMode && (
              <div className="display-mode-modal">
                <div className="display-mode-content">
                  <h3>Режим відображення</h3>
                  <div className="mode-options">
                    <button 
                      className={`mode-btn ${displayMode === 'single-row' ? 'active' : ''}`}
                      onClick={() => updateDisplayMode('single-row')}
                    >
                      В один ряд
                    </button>
                    <button 
                      className={`mode-btn ${displayMode === 'multiple-rows' ? 'active' : ''}`}
                      onClick={() => updateDisplayMode('multiple-rows')}
                    >
                      Розбити один під одним
                    </button>
                  </div>
                  <p className="mode-hint">
                    Поточний режим: <strong>
                      {displayMode === 'single-row' ? 'В один ряд' : 
                       'Розбити один під одним'}
                    </strong>
                  </p>
                  <button 
                    className="close-mode"
                    onClick={() => setShowDisplayMode(false)}
                  >
                    Закрити
                  </button>
                </div>
              </div>
            )}
            
            <button 
              className="settings-btn"
              onClick={() => setShowSettings(!showSettings)}
              title="Налаштування розміщення"
            >
              ⚙️
            </button>
            
            {showSettings && (
              <div className="settings-modal">
                <div className="settings-content">
                  <h3>Розміщення колонки Загальний пул</h3>
                  <div className="position-options">
                    <button 
                      className={`position-btn ${componentPosition === 'left' ? 'active' : ''}`}
                      onClick={() => updateComponentPosition('left')}
                    >
                      Ліворуч
                    </button>
                    <button 
                      className={`position-btn ${componentPosition === 'right' ? 'active' : ''}`}
                      onClick={() => updateComponentPosition('right')}
                    >
                      Праворуч
                    </button>
                    <button 
                      className={`position-btn ${componentPosition === 'bottom' ? 'active' : ''}`}
                      onClick={() => updateComponentPosition('bottom')}
                    >
                      Знизу
                    </button>
                  </div>
                  <p className="settings-hint">
                    Поточна позиція: <strong>
                      {componentPosition === 'left' ? 'Зліва' : 
                       componentPosition === 'right' ? 'Справа' : 
                       'Знизу'}
                    </strong>
                  </p>
                  <button 
                    className="close-settings"
                    onClick={() => setShowSettings(false)}
                  >
                    Закрити
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className="header-info" style={{marginTop: "20px"}}>
          <div className="filter-controls">
            <div className="filter-buttons">
              <button 
                className={`filter-btn ${showDutyTask ? 'active' : ''}`}
                onClick={() => setShowDutyTask(!showDutyTask)}
                title={showDutyTask ? 'Сховати задачних' : 'Показати задачних'}
              >
                {roleIcons['duty_task_yes']} {roleNames['duty_task_yes']}
              </button>
              <button 
                className={`filter-btn ${showDutyChat ? 'active' : ''}`}
                onClick={() => setShowDutyChat(!showDutyChat)}
                title={showDutyChat ? 'Сховати чатних' : 'Показати чатних'}
              >
                {roleIcons['duty_chat_yes']} {roleNames['duty_chat_yes']}
              </button>
              <button 
                className={`filter-btn ${showMentor ? 'active' : ''}`}
                onClick={() => setShowMentor(!showMentor)}
                title={showMentor ? 'Сховати менторів' : 'Показати менторів'}
              >
                {roleIcons['mentor_yes']} {roleNames['mentor_yes']}
              </button>
              <button 
                className={`filter-btn ${showCoordinator ? 'active' : ''}`}
                onClick={() => setShowCoordinator(!showCoordinator)}
                title={showCoordinator ? 'Сховати координаторів' : 'Показати координаторів'}
              >
                {roleIcons['coordinator_yes']} {roleNames['coordinator_yes']}
              </button>
              <button 
                className={`filter-btn ${showTeamlead ? 'active' : ''}`}
                onClick={() => setShowTeamlead(!showTeamlead)}
                title={showTeamlead ? 'Сховати тімлід' : 'Показати тімлід'}
              >
                {roleIcons['teamlead_yes']} {roleNames['teamlead_yes']}
              </button>
            </div>
          </div>
          
          <button 
            className={`archive-toggle-btn ${showArchive ? 'active' : ''}`}
            onClick={() => setShowArchive(!showArchive)}
          >
            {showArchive ? 'Активні задачі' : 'Архів задач'} ({archivedTasks.length})
          </button>
        </div>
      </div>
      
      {showArchive ? (
        <div className="archive-section">
          <h2>Архівовані задачі</h2>
          {archivedTasks.length > 0 ? (
            <div className="archive-grid">
              {archivedTasks.map((task, index) => (
                <ArchivedTaskItem key={`${task.TaskLink || task.taskLink}-${index}`} task={task} />
              ))}
            </div>
          ) : (
            <div className="no-tasks">Немає архівованих задач</div>
          )}
        </div>
      ) : (
        <div className={layoutConfig.className} style={layoutConfig.style}>
          {componentPosition === 'left' && (
            <div className="general-pool-section" style={getGeneralPoolStyle()}>
              <GeneralPoolColumn />
            </div>
          )}
          
          <div className={`users-section ${displayMode === 'single-row' ? 'single-row-mode' : 'multiple-rows-mode'}`}>
            {filteredUsers.length === 0 ? (
              <div className="no-users">Немає користувачів на зміні з задачами</div>
            ) : displayMode === 'single-row' ? (
              <div className="users-grid">
                {filteredUsers.map(user => renderUserColumn(user))}
              </div>
            ) : (
              <>
                {userRows.map((rowUsers, rowIndex) => (
                  <div 
                    key={rowIndex} 
                    className={`users-grid ${rowIndex > 0 ? 'users-grid-new-row' : ''}`}
                  >
                    {rowUsers.map(user => renderUserColumn(user))}
                  </div>
                ))}
              </>
            )}
          </div>
          
          {(componentPosition === 'right' || componentPosition === 'bottom') && (
            <div className="general-pool-section" style={getGeneralPoolStyle()}>
              <GeneralPoolColumn />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default UsersTasksPage;